import { useQuery } from 'react-query'
import { gql } from 'graphql-request'

import graphQLRequest from '@/CandidateExperience/config/graphQLRequest'

const FETCH_CANDIDATE_PROFILE = gql`
  query candidateProfile($id: ID!) {
    candidateProfile(id: $id) {
      slug
      currentState
      canViewPublishedPositions
    }
  }
`

/**
 * Hook for fetching candidate profile data.
 *
 * @param {Object} params
 * @param {string} params.candidateProfileId - The ID of the candidate profile.
 * @param {boolean} [params.refetchOnWindowFocus] - Whether to refetch data when the window regains focus.
 * @param {boolean} [params.enabled] - Whether the query should be enabled.
 * @param {(data: any) => any} [params.select] - A function to select data from the query result.
 * @returns {Object} - The result of the query.
 */
const useFetchCandidateProfile = ({ candidateProfileId, refetchOnWindowFocus, enabled, select }) => {
  return useQuery(['candidateProfile', candidateProfileId], () => graphQLRequest(FETCH_CANDIDATE_PROFILE, { id: candidateProfileId }), {
    refetchOnWindowFocus,
    enabled,
    select,
    staleTime: 5000,
  })
}

export default useFetchCandidateProfile
